import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RemoveShippingAddressForm";
import {cancelRemoveShippingAddress} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class RemoveRemoveShippingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("accountId", this.props.accountId)
                              .set("addressId", this.props.addressId);
    return this.props.removeShippingAddress(updatedValues.toJS())
      .then((response) => {
        if (response.data.removeShippingAddress.errors.length <= 0) {
          this.props.cancelRemoveShippingAddress();
        } else {
          let errors = createValidationErrors(response.data.removeShippingAddress.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRemoveShippingAddress();
  }

  render() {
    return (
      <Form
        label={this.props.label}
        errors={this.state.errors}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REMOVE_SHIPPING_ADDRESS = gql`
  mutation removeShippingAddress($data: RemoveShippingAddressInput!) {
    removeShippingAddress(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REMOVE_SHIPPING_ADDRESS, {
    props: ({ mutate }) => ({
      removeShippingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const RemoveRemoveShippingAddressFormContainerWithData = withMutation(RemoveRemoveShippingAddressFormContainer);

export default connect(null, {cancelRemoveShippingAddress})(RemoveRemoveShippingAddressFormContainerWithData);